import { GsFormField } from '../../../components';
import { Mode } from './swiper.schema';

export const DISPLAY_MODE_SCHEMA: GsFormField<never>[] = [
  {
    formControlName: 'mode',
    label: 'schema.displayMode.name',
    type: 'select',
    valueType: 'number',
    default: Mode.GRID,
    options: [
      { text: 'schema.displayMode.grid', value: Mode.GRID },
      { text: 'schema.displayMode.slider', value: Mode.SLIDER }
    ]
  }
];
